// extracted by mini-css-extract-plugin
export default {"leading-normal":"Inputs_leading-normal__1ZsJm","MuiOutlinedInput-root":"Inputs_MuiOutlinedInput-root__xp9PZ","MuiOutlinedInput-input":"Inputs_MuiOutlinedInput-input__eq8K-"};